import React, { useEffect, useState } from "react";
import { useFormik } from "formik";
import * as yup from "yup";
import PhoneInput from "react-phone-input-2";
import CustomInput from "../../Common/CustomInput/CustomInput";
import Spinner from "../../Layouts/Spinner";
import swal from "sweetalert";
import { useNavigate, useParams } from "react-router-dom";
import {
  generateNewReferralCodeRefer,
  getReferralListDataReferal,
  getUserById,
  updateReferalUser,
} from "../../../redux/referals/actions";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import CommonPagination from "../../Common/Pagination/CommonPagination";
import { CardBody } from "reactstrap";
import Copy from "../../assets/images/copy-img.svg";

const addreferalSchema = () =>
  yup.object({
    first_name: yup
      .string()
      .required("This field is required")
      .min(2, "Enter at least two character")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value && value.trim().length > 0
      ),

    last_name: yup
      .string()
      .required("This field is required")
      .test(
        "not-only-spaces",
        "Please enter a valid value",
        (value) => value.trim() !== ""
      ),
    mobile_number: yup
      .string()
      .min(9, "minimum of 9 numbers required")
      .max(10, "Maximum of 10 number you can use")
      .required("mobile number is required"),
    email_id: yup
      .string()
      .email("Enter a valid email address")
      .test(
        "optional-email-validation",
        "Enter a valid email address",
        (value) =>
          !value ||
          /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(value)
      ),
    code: yup.string().required("Code is Required"),
    start_date: yup
      .date()
      // .min(today, "Start date cannot be in the past")
      .required("Start date is required"),
    end_date: yup
      .date()
      .min(yup.ref("start_date"), "End date cannot be before start date")
      .required("End date is required"),
    percentage_from: yup.string().required("Referal from is Required"),
    percentage_to: yup.string().required("Referal to is Required"),
  });

const UpdateReferalUser = () => {
  const navigate = useNavigate();
  const params = useParams();
  const dispatch = useDispatch();
  const [isLoading, setIsLoading] = useState(false);
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const ReferalUserDetails = useSelector(
    (state) => state.Referaluser?.Refaraluserbyid
  );
  const [params2, setParams] = useState({
    user_id: ReferalUserDetails.referral?.user_id,
  });
  const refData = useSelector((state) => state?.reusableSlice?.getReferralData);
  const formik = useFormik({
    initialValues: {
      first_name: ReferalUserDetails.first_name
        ? ReferalUserDetails.first_name
        : "",
      last_name: ReferalUserDetails.last_name
        ? ReferalUserDetails.last_name
        : "",
      mobile_number: ReferalUserDetails.mobile_number
        ? ReferalUserDetails.mobile_number
        : "",
      email_id: ReferalUserDetails.email_id ? ReferalUserDetails.email_id : "",
      country_code: ReferalUserDetails.country_code
        ? ReferalUserDetails.country_code
        : "",
      code: ReferalUserDetails.referral?.code
        ? ReferalUserDetails.referral?.code
        : "",
      percentage_from: ReferalUserDetails.referral?.percentage_from
        ? ReferalUserDetails.referral?.percentage_from
        : "",
      start_date: ReferalUserDetails.referral?.start_date
        ? ReferalUserDetails.referral?.start_date
        : "",
      end_date: ReferalUserDetails.referral?.end_date
        ? ReferalUserDetails.referral?.end_date
        : "",
      percentage_to: ReferalUserDetails.referral?.percentage_to
        ? ReferalUserDetails.referral?.percentage_to
        : "",
    },
    validationSchema: addreferalSchema(),
    enableReinitialize: true,
    onSubmit: (values) => handleAddReferalUser(values),
  });

  const handleAddReferalUser = (values) => {
    const data = {
      first_name: values.first_name,
      last_name: values.last_name,
      country_code: values.country_code,
      mobile_number: values.mobile_number,
      email_id: values.email_id,
      id: params.uid,
      referral: {
        code: values.code,
        id: ReferalUserDetails.referral.id,
        start_date: values.start_date,
        end_date: values.end_date,
        percentage_from: values.percentage_from,
        percentage_to: values.percentage_to,
        user_id: ReferalUserDetails.referral.user_id,
      },
    };
    setIsLoading(true);
    dispatch(updateReferalUser(data, setIsLoading));
  };

  const handleCountryCode = (value, data) => {
    formik.setFieldValue(
      "mobile_number",
      `${value.slice(data.dialCode.length)}`
    );
    formik.setFieldValue("country_code", `+${data.dialCode}`);
  };

  const handleStartDateChange = (e) => {
    const selectedDate = e.target.value;
    if (endDate && new Date(selectedDate) > new Date(endDate)) {
      swal({
        text: "Start date cannot be greater than the end date!",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
      return;
    }
    formik.setFieldValue("start_date", selectedDate);
    setStartDate(selectedDate);
  };

  const handleEndDateChange = (e) => {
    const selectedDate = e.target.value;
    if (startDate && new Date(selectedDate) < new Date(startDate)) {
      swal({
        text: "End date cannot be less than the start date!",
        icon: "error",
        button: "Close",
        timer: 1500,
      });
      return;
    }
    formik.setFieldValue("end_date", selectedDate);
    setEndDate(selectedDate);
  };

  const handleGetNewReferralCode = () => {
    dispatch(
      generateNewReferralCodeRefer({
        id: ReferalUserDetails.referral.id,
        userID: params.uid,
      })
    );
  };

  const handleCopyReferral = (code) => {
    try {
      const input = document.createElement("input");
      input.value = code;
      document.body.appendChild(input);
      input.select();
      document.execCommand("copy");
      document.body.removeChild(input);
      alert("code is copied succcessfully");
    } catch (err) {
      console.error("Error copying text:", err);
     
    }
  };
  useEffect(() => {
    dispatch(getUserById(params.uid));
  }, [params.uid]);

  useEffect(() => {
    ReferalUserDetails.referral?.user_id &&
      dispatch(
        getReferralListDataReferal({
          user_id: ReferalUserDetails.referral?.user_id,
        })
      );
  }, [params2, ReferalUserDetails]);

  return (
    <div className="px-4 pb-3 pt-5">
      <h3 className="pb-5">Update Customer Referral</h3>
      <form
        onSubmit={formik.handleSubmit}
        onWheel={(e) =>
          e.target.tagName === "INPUT" &&
          e.target.type === "number" &&
          e.target.blur()
        }
      >
        <div className="row">
          <div className="col-md-3 from-group">
            <label>First Name</label>
            <CustomInput
              name="first_name"
              id="first_name"
              type="text"
              placeholer="Enter First Name"
              value={formik.values.first_name}
              onChange={formik.handleChange}
              errors={formik.errors}
              touched={formik.touched}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-3 from-group">
            <label>Last Name</label>
            <CustomInput
              name="last_name"
              id="last_name"
              type="text"
              placeholer="Enter Last Name"
              value={formik.values.last_name}
              onChange={formik.handleChange}
              errors={formik.errors}
              touched={formik.touched}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-3">
            <div className="form-group">
              <label>Mobile Number</label>
              <PhoneInput
                country="sa"
                // value={formik.values.mobile_number}
                value={
                  formik?.values.country_code
                    ? `${formik.values.country_code}${formik.values.mobile_number}`
                    : ""
                }
                onChange={(phone, data) => handleCountryCode(phone, data)}
                onBlur={() => formik.setFieldTouched("mobile_number", true)}
              />
            </div>
            {formik.touched.mobile_number && formik.errors.mobile_number && (
              <p className="error-message">{formik.errors.mobile_number}</p>
            )}
          </div>
          <div className="col-md-3 from-group">
            <label>Email Address (optional) </label>
            <CustomInput
              name="email_id"
              id="email_id"
              type="email"
              placeholer="Enter Email Address"
              value={formik.values.email_id}
              onChange={formik.handleChange}
              errors={formik.errors}
              touched={formik.touched}
              onBlur={formik.handleBlur}
            />
          </div>
          <div className="col-md-3 form-group">
            <label>Referral Code</label>
            <div className="change-btn copy-ref">
              <CustomInput
                type="text"
                errors={formik.errors}
                touched={formik.touched}
                className="form-control"
                placeholder="Enter..."
                name="code"
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                value={formik.values.code}
                disabled
              />
              <div className="copy-ref-token" >
                <img
                  src={Copy}
                  onClick={() => handleCopyReferral(formik.values.code)}
                  alt=""
                />
                <span
                  onClick={() => {
                    handleGetNewReferralCode();
                  }}
                >
                  <span>Generate referral</span>
                </span>
              </div>
            </div>
            {formik.touched.code && formik.errors.code ? (
              <div className="error">{formik.errors.code}</div>
            ) : null}
          </div>
          <div className="col-md-3 form-group">
            <label>Referrer reward (SAR)</label>
            <input
              type="number"
              className="form-control"
              placeholder="Enter percentage from"
              name="percentage_from"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.percentage_from}
            />
            {formik.touched.percentage_from && formik.errors.percentage_from ? (
              <div className="error">{formik.errors.percentage_from}</div>
            ) : null}
          </div>
          <div className="col-md-3 form-group">
            <label>Referee reward (SAR)</label>
            <CustomInput
              id="percentage_to"
              type="number"
              errors={formik.errors}
              touched={formik.touched}
              className="form-control"
              placeholder="Enter percentage to"
              name="percentage_to"
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              value={formik.values.percentage_to}
            />
          </div>

          <div className=" form-group mx-1">
            <label>Start Date</label>
            <CustomInput
              type="date"
              name="start_date"
              id="start_date"
              className="form-control"
              errors={formik.errors}
              touched={formik.touched}
              value={formik.values.start_date}
              onChange={handleStartDateChange}
            />
          </div>

          <div className="form-group mx-3">
            <label>End Date</label>
            <CustomInput
              type="date"
              name="end_date"
              id="end_date"
              errors={formik.errors}
              touched={formik.touched}
              className="form-control"
              value={formik.values.end_date}
              //   value={endDate}
              onChange={handleEndDateChange}
            />
          </div>
          <div className="col-md-12 text-center my-3 d-flex align-items-center justify-content-center col-gap-10">
            <button
              className="submit-btn"
              disabled={isLoading}
              onClick={() => navigate(-1)}
              type="button"
              style={{ marginRight: "20px" }}
            >
              Back
            </button>
            <button className="submit-btn" disabled={isLoading} type="submit">
              {!isLoading ? "Update User" : <Spinner />}
            </button>
          </div>
        </div>
      </form>

      <CardBody className="table-sec px-3">
        <table className="table">
          <thead>
            <tr>
              <th>Sl. No</th>
              <th>Full Name</th>
              <th>Email</th>
              <th>Mobile Number</th>
              <th>Referral Amount</th>
            </tr>
          </thead>
          <tbody>
            {refData?.referrals?.length > 0 ? (
              refData?.referrals?.map((addr, index) => (
                <tr key={addr.id}>
                  <td>{index + 1 + (params2?.page - 1) * 10}</td>
                  <td>
                    {addr?.first_name} {addr?.last_name}
                  </td>
                  <td>{addr?.email_id}</td>
                  <td>
                    {addr?.country_code} {addr?.mobile_number}
                  </td>
                  <td>{addr?.re_amount}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="5" style={{ textAlign: "center" }}>
                  No Referrals found
                </td>
              </tr>
            )}
          </tbody>
        </table>
        <CommonPagination
          params={params2}
          setParams={setParams}
          pagination_meta={refData?.pagination}
        />
      </CardBody>
    </div>
  );
};

export default UpdateReferalUser;
